import { render, staticRenderFns } from "./ServicesReport.vue?vue&type=template&id=51be1490&scoped=true&"
import script from "./ServicesReport.vue?vue&type=script&lang=ts&"
export * from "./ServicesReport.vue?vue&type=script&lang=ts&"
import style0 from "./ServicesReport.vue?vue&type=style&index=0&id=51be1490&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51be1490",
  null
  
)

export default component.exports